<template>
  <div>
    <Header>
      Edycja fryzjera: {{ barber.name }}
    </Header>

    <b-row>
      <b-col xl="6" order-xl="2" class="mb-3">
        <div class="mb-3">
          <b-link :href="barber.photo_url" target="_blank">
            <b-avatar
              :src="barber.photo_url"
              variant="primary"
              :rounded="true"
              size="10em"
            />
          </b-link>
        </div>

        <b-form-checkbox v-if="barber.photo" v-model="form.deletePhoto" class="mb-3">
          Usuń zdjęcie
        </b-form-checkbox>
        <b-form-file v-model="form.photo" accept="image/*" plain/>

        <hr>
      </b-col>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group>
            <b-checkbox v-model="form.isOnline">Rezerwacje online</b-checkbox>
          </b-form-group>
          <b-form-group label="Użytkownik B2B:">
            <b-form-select
              v-model="form.b2bUserId"
              :options="select_users"
            />
          </b-form-group>
          <b-form-group>
            <strong>Rezerwacje:</strong>
            <span v-if="form.isOnline">
              online + telefoniczne
              <b-icon icon="globe2" class="text-primary"/>
            </span>
            <span v-else>
              tylko telefoniczne
              <b-icon icon="telephone-fill" class="text-warning"/>
            </span>
          </b-form-group>
          <b-form-group label="Kolejność">
            <b-input v-model="form.priority"/>
          </b-form-group>
          <b-form-group label="Imię">
            <b-input v-model="form.firstName" required/>
          </b-form-group>
          <b-form-group label="Nazwisko">
            <b-input v-model="form.lastName"/>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('barbers.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
                <b-button
                  :variant="!barber.deleted_at ? 'danger' : 'success'"
                  :disabled="formDelete.processing"
                  @click="deleteBarber"
                >
                  <b-icon v-if="!barber.deleted_at" icon="trash"/>
                  <b-icon v-else icon="arrow-clockwise"/>
                </b-button>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="check"/>
                  Zapisz
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from "../../Layouts/Components/Errors";

export default {
  layout: Layout,
  components: {
    Errors,
    Header,
  },
  props: {
    barber: Object,
    users: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        firstName: this.barber.first_name || '',
        lastName: this.barber.last_name || '',
        priority: this.barber.priority || '',
        isOnline: this.barber.is_online || false,
        b2bUserId: this.barber.b2b_user_id,
        photo: null,
        deletePhoto: false,
      }),
      formDelete: this.$inertia.form({}),
    }
  },
  computed: {
    select_users() {
      return [
        {
          value: null,
          text: '-- Brak --',
        },
      ].concat(this.users.map((user) => {
        return {
          value: user.id,
          text: user.name,
        }
      }))
    },
  },
  methods: {
    submit() {
      this.form.post(this.route('barbers.update', this.barber.id))
    },
    async deleteBarber() {
      if (!this.barber.deleted_at) {
        const confirmation = await this.$bvModal.msgBoxConfirm(
          'Czy na pewno chcesz usunąć?',
          {
            title: 'Usuwanie',
            okVariant: 'danger',
            okTitle: 'Usuń',
            cancelTitle: 'Anuluj',
            cancelVariant: 'light',
            hideHeaderClose: false,
            centered: true,
          }
        )
        if (!confirmation) return
      }

      this.formDelete.delete(this.route('barbers.destroy', this.barber.id))
    },
  },
}
</script>
